@if (!isSSR) { @if (exhibition_halls | Count) { @for (hall of exhibition_halls; track identifyHall($index, hall)) {
<div class="exhibited-at" [class.exhibited-at--inline]="inline">
  @if (prefix) {
  <span>{{ localized_prefix === 'undefined' ? '' : localized_prefix }}</span>
  } @for (booth of hall.booths; track identifyBooth($index, booth)) {
  <div planoneLocationLink [booth]="booth" [hall]="hall" [fairId]="fair_id" [clickable]="locationClickable">
    @if (hasIcon) {
    <mat-icon class="exhibited-at__icon action__icon">map</mat-icon>
    }
    <span>{{ { hall, booth } | LocationName }}</span>
  </div>
  }
</div>
} } @else {
{{ localized_prefix === 'undefined' ? '' : localized_prefix }}
} }
